import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let HidratacionService = class HidratacionService {
    constructor(http) {
        this.http = http;
        this.cargadoHidratacion = true;
        this.hidratacion = [];
        this.hidratacionRFL = [];
        this.hidratacionRFC = [];
        this.hidratacionRFP = [];
        this.hidratacionRCL = [];
        this.hidratacionRCC = [];
        this.hidratacionRCP = [];
        this.cargarHidratacion();
    }
    cargarHidratacion() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.hidratacion = resp;
                this.hidratacionRFL = this.hidratacion[12].rutinafacial.limpieza;
                this.hidratacionRFC = this.hidratacion[12].rutinafacial.cuidado;
                this.hidratacionRFP = this.hidratacion[12].rutinafacial.proteccion;
                this.hidratacionRCL = this.hidratacion[12].rutinacorporal.limpieza;
                this.hidratacionRCC = this.hidratacion[12].rutinacorporal.cuidado;
                this.hidratacionRCP = this.hidratacion[12].rutinacorporal.proteccion;
                setTimeout(() => {
                    this.cargadoHidratacion = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
HidratacionService.ctorParameters = () => [
    { type: HttpClient }
];
HidratacionService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], HidratacionService);
export { HidratacionService };
//# sourceMappingURL=hidratacion.service.js.map